import { PopupState } from "./module/popup/types";

export interface AppState {
  dropdowns: DropdownsState;
  simpleDropdown: SimpleDropdownState;
  customerDeviceType: DeviceType;
  activeActionBar?: ActionBarNames;
  popup: PopupState;
  activeLoaders: { [key in LoaderType]?: boolean };
  mobileView: MobileView;
  showRealisticPreview: boolean;
  /**
   * GAPI-30848 multi-technology editor mode.
   * When true, the global Technology toggle is hidden and the bottom
   * thumbnail strip renders all spreads with per-area tech badges.
   * Set by the parent (storefronts) via the `setMultiTechProductData`
   * post-message.
   */
  multiTechMode?: boolean;
  /**
   * GAPI-30848: per-area technology grouping. Each entry represents one
   * physical print area (canonical name) and the techs available for it.
   * Set via the `setMultiTechAreaGroups` post-message.
   */
  multiTechAreaGroups?: MultiTechAreaGroup[];
  /**
   * GAPI-30848: which technology is currently active for each canonical
   * area. Defaults to the first option in each group; updated when the
   * customer switches via the per-area picker.
   */
  selectedTechByArea?: Record<string, string>;
}

export interface MultiTechAreaGroup {
  canonicalName: string;
  displayName: string;
  options: Array<{ technology: string; spreadName: string }>;
}

export type MobileView = "spreads" | "canvas";

export enum ActionBarNames {
  FontFamilies = "FontFamilies",
  FontColors = "FontColors",
  ReplaceImage = "ReplaceImage",
}

export enum TopMenuDropdown {
  Position = "Position",
  ProductFitting = "ProductFitting",
  ImageEffects = "ImageEffects",
  FontSize = "FontSize",
  TextAlign = "TextAlign",
  TextSpacing = "TextSpacing",
  TextFitting = "TextFitting",
  CropZoom = "CropZoom",
  Personalization = "Personalization",
  SVGColor = "SVGColor",
  LineStyles = "LineStyles",
  RectangleStyles = "RectangleStyles",
  LineEdge1 = "LineEdge1",
  LineEdge2 = "LineEdge2",
  ThreadColor = "ThreadColor",
  ProductSwitcher = "ProductSwitcher",
  ImageInfo = "ImageInfo",
}

export enum DeviceType {
  Mobile = "Mobile",
  Tablet = "Tablet",
  Desktop = "Desktop",
}

export enum LoaderType {
  EditorArea = "EditorArea",
  ProductPersonalizerPreview = "ProductPersonalizerPreview",
}

export interface DropdownsState {
  activeAddLayerDropdown?: string;
  activeTopMenuDropdown?: TopMenuDropdown;
  mobileMoreMenuDropdown?: string;
}

export interface SimpleDropdownState {
  name?: string | null;
  data?: any;
}

export interface AuthHeader {
  [key: string]: string;
}

export declare type TextEffectControl =
  | "shadow"
  | "outline"
  | "pattern"
  | "curve";
